module.exports = "/templates/bds/public/images/527eadff60a26085e5dea383fd6b74d7.png";